import React, { useEffect} from "react";
import styles from "./paginator.module.css";


const Paginator = ({ page, setPage, pages }) => {

  useEffect(() => {
    window.scrollTo({
      top:0, left: 0,
      behavior: 'smooth'
    });
  }, [page]);

  return (
    <div className={styles.container}>
      {pages > 5 ?
        <>
          {page !== 1 &&
            <>
              <button
                onClick={() => setPage(1)}
                disabled={page === 1}
                className={styles.button}
              >
                1
              </button>
              <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                className={styles.button}
              >
                {"<"}
              </button>
            </>
          }
          <button
            className={`${styles.button} ${styles.button__active}`}
          >
            {page}
          </button>
          {page !== pages &&
            <>
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === pages}
                className={styles.button}
              >
                {">"}
              </button>
              <button
                onClick={() => setPage(pages)}
                disabled={page === pages}
                className={styles.button}
              >
                {pages}
              </button>
            </>
          }
        </> :
        <>
          <button
            onClick={() => setPage(1)}
            disabled={page === 1}
            className={`${styles.button} ${page === 1 && styles.button__active}`}
          >
            1
          </button>
          <button
            onClick={() => setPage(2)}
            disabled={page === 2}
            className={`${styles.button} ${page === 2 && styles.button__active}`}
          >
            2
          </button>
          {pages >= 3 &&
            <button
              onClick={() => setPage(3)}
              disabled={page === 3}
              className={`${styles.button} ${page === 3 && styles.button__active}`}
            >
              3
            </button>
          }
          {pages >= 4 &&
            <button
              onClick={() => setPage(4)}
              disabled={page === 4}
              className={`${styles.button} ${page === 4 && styles.button__active}`}
            >
              4
            </button>
          }
          {pages >= 5 &&
            <button
              onClick={() => setPage(5)}
              disabled={page === 5}
              className={`${styles.button} ${page === 5 && styles.button__active}`}
            >
              5
            </button>
          }
        </>
      }

    </div>
  );
}

export default Paginator;
